import { Table, Input, Card } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { $ } from '../../lib/api';

export interface GenericListProps {
  endpoint: string;
  title: string;
  columns: any[];
  searchPlaceholder?: string;
}

export function GenericList({ endpoint, title, columns, searchPlaceholder }: GenericListProps) {
  const [params, setParams] = useState<any>({ page: 1, pageSize: 20 });
  const { data, isLoading } = useQuery({
    queryKey: [endpoint, params],
    queryFn: () => $.get(endpoint, params),
  });
  return (
    <Card title={title} extra={
      searchPlaceholder && (
        <Input.Search style={{ width: 280 }} placeholder={searchPlaceholder}
          onSearch={(q) => setParams({ ...params, q, page: 1 })} />
      )
    }>
      <Table
        rowKey="id"
        loading={isLoading}
        columns={columns}
        dataSource={data?.items ?? data ?? []}
        pagination={{
          current: params.page,
          pageSize: params.pageSize,
          total: data?.total,
          onChange: (page, pageSize) => setParams({ ...params, page, pageSize }),
        }}
      />
    </Card>
  );
}
